import { postGQLFields } from '../post/posts.fields.js';
export function spacePostsGQLFields(fields) {
    return `
      posts(limit: ${fields.variables.limit || 1}) {
        edges {
          cursor
          node {
            ${postGQLFields(fields.fields)}
          }
        }
        nodes {
          ${postGQLFields(fields.fields)}
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        totalCount
      }
    `;
}
//# sourceMappingURL=spacePosts.fields.js.map